import { TimelineTime, TimelineTrack } from "../types";

export function timeFromEvent(
  event: React.MouseEvent<HTMLDivElement> | MouseEvent,
  scrollContainer: HTMLDivElement | null,
  totalDuration: TimelineTime,
  pixelsPerMs: number,
  offsetPx: number = 0
): TimelineTime | null {
  if (!scrollContainer) return null;
  const rect = scrollContainer.getBoundingClientRect();
  const offsetX =
    event.clientX - rect.left + scrollContainer.scrollLeft - offsetPx;
  const time = Math.max(0, Math.min(offsetX / pixelsPerMs, totalDuration));
  return time;
}

export function labelByKind(kind: TimelineTrack["kind"]): string {
  if (kind === "audio") return "Audio";
  if (kind === "image") return "Images";
  if (kind === "shot") return "Shots";
  if (kind === "lyrics") return "Lyrics";
  return "Videos";
}

export function formatDuration(value: TimelineTime): string {
  const totalMs = value;
  const totalSeconds = totalMs / 1000;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  // 如果大于等于1分钟，展示 XmXs 格式
  if (minutes > 0) {
    const wholeSeconds = Math.floor(seconds);
    if (wholeSeconds === 0) {
      return `${minutes}m`;
    }
    return `${minutes}m${wholeSeconds}s`;
  }

  // 如果小于1分钟，展示 x.xs 格式（精确到小数点一位）
  const roundedSeconds = Math.round(seconds * 10) / 10;

  // 如果四舍五入后达到60秒，应该展示为 1m
  if (roundedSeconds >= 60) {
    return "1m";
  }

  const wholePart = Math.floor(roundedSeconds);
  const decimalPart = roundedSeconds - wholePart;

  // 如果小数位是0，不展示小数部分
  if (decimalPart === 0) {
    return `${wholePart}s`;
  }

  return `${roundedSeconds.toFixed(1)}s`;
}

export function formatMs(
  value: TimelineTime,
  format: "MM:SS" | "MMmSSs" = "MM:SS",
  showMilliseconds = false
): string {
  const totalSeconds = Math.ceil(value / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = value % 1000;

  if (format === "MMmSSs") {
    const m = minutes > 0 ? `${minutes}m` : "";
    const s = seconds > 0 ? `${seconds}s` : "";
    return `${m}${s}`;
  }

  return `${padNumber(minutes)}:${padNumber(seconds)}${
    showMilliseconds ? `.${padMs(milliseconds)}` : ""
  }`;
}

export function padNumber(value: number): string {
  return value.toFixed(0).padStart(2, "0");
}

export function padMs(value: number): string {
  return value.toFixed(0).padStart(3, "0");
}
